import { Api } from '../../apis/api';
import { addFloats } from '../../utils/numbers';
import { FunnelController } from '../business/FunnelController';

export class ThankYouController {
  private fc: FunnelController;

  constructor(fc: FunnelController) {
    this.fc = fc;
  }

  private fetchOrderItems = async () => {
    const lead = this.fc.lead.lead;
    try {
      if (lead && lead.orderId) {
        return Api.queryOrder(lead.orderId);
      }
    } catch (e) {
      Errors.report(e, {
        geo: window.GEO,
        config: this.fc.config,
        lead: this.fc.lead.lead,
      });
    }
  };

  injectInfo = async () => {
    const orderSummary = await this.fetchOrderItems();

    try {
      const currency = orderSummary?.currencySymbol;
      const totalAmount = document.getElementById('totalAmount');
      if (totalAmount) {
        totalAmount.textContent = `${currency}${orderSummary?.totalAmount}`;
      }

      const products = orderSummary?.products;
      const demoRow = document.getElementById('productRow');
      const summaryTable = document.getElementById('summaryTable');
      if (summaryTable && demoRow && products && products?.length > 0) {
        products.forEach(p => {
          const newRow = demoRow.cloneNode(true) as HTMLDivElement;
          newRow.id = `productRow${p.productId}`;

          const image = newRow.querySelector(
            '#productImage',
          ) as HTMLImageElement;
          const title = newRow.querySelector('#productTitle') as HTMLDivElement;
          const price = newRow.querySelector('#productPrice') as HTMLDivElement;
          const shippingPrice = newRow.querySelector(
            '#productShipPrice',
          ) as HTMLDivElement;
          const totalPrice = newRow.querySelector(
            '#productTotal',
          ) as HTMLDivElement;

          if (image && p?.imageUrl) {
            image.src = p.imageUrl;
          }
          if (title) {
            title.textContent = p.name;
          }
          if (price) {
            price.textContent = `${currency}${p.price}`;
          }
          if (shippingPrice) {
            shippingPrice.textContent = `${currency}${p.shipping}`;
          }
          if (totalPrice) {
            const totalProductAmount = addFloats(p.price, p.shipping);
            totalPrice.textContent = `${currency}${totalProductAmount.toFixed(
              2,
            )}`;
          }

          summaryTable.append(newRow);
        });
      }
      demoRow?.remove();
    } catch (e) {
      Errors.report(e, {
        orderSummary,
        geo: window.GEO,
        config: this.fc.config,
        lead: this.fc.lead.lead,
      });
    }
  };
}
